// extracted by mini-css-extract-plugin
module.exports = {"pageContentMain":"main-wrapper_pageContentMain__1vpWd"};